import { z } from 'zod';
import { BaseFieldDefinitionSchema } from './base';
import { FieldDefinitionSchema } from './composite';
export var ObjectFieldDefinition;
(function (ObjectFieldDefinition) {
    ObjectFieldDefinition.TYPE = 'object';
})(ObjectFieldDefinition || (ObjectFieldDefinition = {}));
export const ObjectFieldDefinitionSchema = BaseFieldDefinitionSchema.and(z.object({
    type: z.literal(ObjectFieldDefinition.TYPE),
    fieldDefinitions: z.array(z.lazy(() => FieldDefinitionSchema))
}));
//# sourceMappingURL=object.js.map